import { Link, NavLink, useLocation } from 'react-router-dom'

const Sidebar = () => {
	const location = useLocation()

	if (location.pathname === '/login' || location.pathname === '/') {
		return false
	}

	return (
		<aside className='sidebar'>
			<h1>
				<Link to='/dashboard'>Administrator</Link>
			</h1>
			<ul>
				<li>
					<NavLink to='/dashboard'>Dashboard</NavLink>
				</li>
				<li>
					<NavLink to='/posts'>Blog Posts</NavLink>
				</li>
				<li>
					<NavLink to='/newsletters'>Newsletters</NavLink>
				</li>
				<li>
					<NavLink to='/contacts'>Contact Infos</NavLink>
				</li>
				<li>
					<NavLink to='/members'>Team Members</NavLink>
				</li>
			</ul>
		</aside>
	)
}

export default Sidebar
